import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { Globe, LogOut, Moon, Sun } from "lucide-react";
import { useSuiteTheme } from "@athavita/ui-theme";

export function HostingShell() {
    const auth = useAuth();
    const navigate = useNavigate();
    const { theme, toggle } = useSuiteTheme();
    const displayName = auth.user?.profile.name ?? auth.user?.profile.email ?? "Signed in";

    return (
        <div className="flex h-screen flex-col bg-background text-foreground">
            <header className="flex h-12 shrink-0 items-center gap-3 border-b bg-primary px-3 text-primary-foreground">
                <Globe className="h-5 w-5" aria-hidden />
                <button
                    type="button"
                    onClick={() => navigate("/")}
                    className="font-semibold hover:underline"
                >
                    Athavita Hosting
                </button>
                <div className="ml-auto flex items-center gap-1">
                    <button
                        type="button"
                        onClick={toggle}
                        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                        title={theme === "dark" ? "Light mode" : "Dark mode"}
                        className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-white/10"
                    >
                        {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                    </button>
                    <span className="px-2 text-sm opacity-80" title={displayName}>{displayName}</span>
                    <button
                        type="button"
                        onClick={() => void auth.signoutRedirect()}
                        aria-label="Sign out"
                        title="Sign out"
                        className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-white/10"
                    >
                        <LogOut className="h-4 w-4" />
                    </button>
                </div>
            </header>
            <main className="flex-1 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
}
